const productColumns = [
  {
    key: "num",
    label: "SN.",
  },
  {
    key: "imageUrl",
    label: "Image",
  },
  {
    key: "name",
    label: "Name",
  },

  {
    key: "weight",
    label: "Weight",
  },
  {
    key: "price",
    label: "Price",
  },
  {
    key: "actions",
    label: "Actions",
  },
];

export { productColumns };
